/* global theme */

import { fetchConfig } from './global';

import jQuery from 'jquery';
import BsubWidget from '../js/bsubwidget.js';

String.prototype.interpolate = function(params) {
  const names = Object.keys(params);
  const vals = Object.values(params);
  return new Function(...names, `return \`${this}\`;`)(...vals);
}

class SubscriptionBuilder extends BsubWidget {
    constructor () {
        super();
        this.attrs.productList = 'data-builder-product-options';
        this.attrs.productOptions = 'data-builder-product-option';
        this.attrs.subscriptionOptions = 'data-builder-subscription-options';

        this.templates = {
            product: 'tmpl-product',
            productAfter: 'tmpl-product-after',
            subscriptionOption: 'tmpl-subscription-option'
        }

        // autogenerate selectors from attributes
        Object.entries(this.attrs).forEach(function ([key, value]) {
            this.selectors[key] = `[${value}]`;
        }.bind(this));
    }
    init () {
        //console.debug('BSUBBUILDER: Initializing widgets...');
        if (!document.querySelector(this.selectors.productList)) {
            //console.debug('BSUBBUILDER: No widgets detected, skipping initialization.');
            return;
        }

        var _this = this;
        var productTemplate = document.getElementById(this.templates.product) ? document.getElementById(this.templates.product).innerHTML : false;
        var productAfterTemplate = document.getElementById(this.templates.productAfter) ? document.getElementById(this.templates.productAfter).innerHTML : false;
        var subscriptionOptionTemplate = document.getElementById(this.templates.subscriptionOption) ? document.getElementById(this.templates.subscriptionOption).innerHTML : false;

        var allProductsData = document.querySelectorAll(_this.selectors.productJson);

        var allProducts = [];

        allProductsData.forEach(function(allProductData){
            var json = JSON.parse(allProductData.innerHTML);
            json.meta = {};
            if(allProductData.hasAttribute('data-bsub-case-size')) json.meta.subscription_case_size = allProductData.getAttribute('data-bsub-case-size');
            if(allProductData.hasAttribute('data-bsub-subscription-title')) json.title = allProductData.getAttribute('data-bsub-subscription-title');
            if(allProductData.hasAttribute('data-bsub-subscription-image')) json.meta.subscription_image = allProductData.getAttribute('data-bsub-subscription-image');
            json.data_product_section = allProductData.getAttribute('data-product-section');
            allProducts.push(json);
        });

        var allPlanOptions = {};

        if(allProducts.length > 0){

            var productLists = document.querySelectorAll(_this.selectors.productList);
            var subscriptionOptions = document.querySelectorAll(_this.selectors.subscriptionOptions);

            productLists.forEach(function (productList) {

                var productListGroupId = parseInt(productList.getAttribute('data-subscription-group'));
                var productListGroup = window.BOLD.subscriptions.getSubscriptionGroupById(parseInt(productListGroupId));
                var productListGroupProductIds = productListGroup.selection_options;
                var productListSectionID = productList.getAttribute('data-accordion-section');

                var productListHtml = '';

                allProducts.forEach(function(product){

                    if(productListGroupProductIds.find(o => o.platform_entity_id == product.id) && product.selling_plan_groups.length > 0 && product.data_product_section == productListSectionID){

                        productListHtml += productTemplate.interpolate({ product: product, group: productListGroup });

                        product.selling_plan_groups.forEach(function(sellingPlanGroup){

                            sellingPlanGroup.selling_plans.forEach(function(sellingPlanGroupSellingPlan){

                                allPlanOptions[sellingPlanGroupSellingPlan.name] = sellingPlanGroupSellingPlan

                            })

                        });

                    }

                });

                console.log('allPlanOptions', allPlanOptions)

                //if(productAfterTemplate) productListHtml += productAfterTemplate;

                productList.innerHTML = productListHtml;

                this._initProductList(productList);

                var productGroupBillingIds = productListGroup.billing_rules;

                var productBillingHtml = '';

                productGroupBillingIds.forEach(function(billingPlan){

                    if(allPlanOptions[billingPlan.interval_name]){

                        billingPlan.data = allPlanOptions[billingPlan.interval_name];

                        billingPlan.split_name = '<span>' + billingPlan.interval_name.split(' ').join('</span><span>') + '</span>';

                        // TODO: Rename the plan in SKIO
                        if (billingPlan.interval_name == 'Monthly') billingPlan.split_name = '<span>4</span><span>weeks</span>';

                        //console.log('billingPlans', billingPlan);

                        productBillingHtml += subscriptionOptionTemplate.interpolate({ plan: billingPlan });

                    }

                });

                subscriptionOptions[0].innerHTML = productBillingHtml;

                this._initOptionsAndSubmit(subscriptionOptions[0], productList);

                // this._renderPrices(widget);
                // this._renderGroupDiscountSummary(widget);

            }.bind(_this));

            let totalproducts = 0;

            jQuery('.jic-subscription-builder').find('input[type="number"]').each(function () {
                totalproducts += parseInt(jQuery(this).val());
            });

            // Mobile sticky message
            if (window.mobile_sticky_messages != undefined) {
                let mobileMessage = jQuery('.next-message');
                mobileMessage.html('');
                window.mobile_sticky_messages.forEach(function (el) {
                    if (totalproducts >= el.min && totalproducts <= el.max) {
                        mobileMessage.html(el.message);
                    }
                });
            }

        }
    }
    _initProductList (productList) {

        jQuery(productList).find('.number-input input[type="button"]').click(function () {

            var adjustment = jQuery(this).hasClass('button-plus') ? 1 : -1 ;

            const currentVal = parseInt(jQuery(this).parent().find('input[type="number"]').first()
                .val(), 10);

            if (!isNaN(currentVal)) {
                jQuery(this).parent().find('input[type="number"]').first()
                    .val(Math.max(currentVal + adjustment, 0))
                    .trigger('change');
            } else {
                jQuery(this).parent().find('input[type="number"]').first()
                    .val(0)
                    .trigger('change');
            }

            let totalproducts = 0;

            jQuery('.jic-subscription-builder').find('input[type="number"]').each(function () {
                totalproducts += parseInt(jQuery(this).val());
            });

            console.log('BUSINESS SUBS;', totalproducts)

            /*if (totalproducts > 7) {
                console.log('1')
                jQuery('.jic-subscription-builder').find('h5.product-price').each(function(){
                    jQuery(this).find('strong').text(` £${((parseInt(this.dataset.price)-600)/100)}`);
                })
            }else */
            if (totalproducts >= 4) {
                console.log('1')
                jQuery('.jic-subscription-builder').find('h5.product-price').each(function(){
                    jQuery(this).find('strong').text(` £${(((parseInt(this.dataset.price)/100)*80)/100).toFixed(2).replace(/[.,]00$/, "")}`);
                })
            } else if (totalproducts >= 2) {
                console.log('2')
                jQuery('.jic-subscription-builder').find('h5.product-price').each(function(){
                    jQuery(this).find('strong').text(` £${(((parseInt(this.dataset.price)/100)*85)/100).toFixed(2).replace(/[.,]00$/, "")}`);
                })
            }else{
                console.log('3')
                jQuery('.jic-subscription-builder').find('h5.product-price').each(function(){
                    jQuery(this).find('strong').text(` £${(parseInt(this.dataset.price)/100).toFixed(2).replace(/[.,]00$/, "")}`);
                })
            }

            if (totalproducts > 1) {
                /*
                if (totalproducts > 7) {
                    jQuery('.buying-for-business').show();
                } else {
                    jQuery('.buying-for-business').hide();
                }
                 */

                jQuery('.subscription-action-buttons .open-how-often').prop( "disabled", false );

            } else {

                jQuery('.subscription-action-buttons .open-how-often').prop( "disabled", false );

                //jQuery('.buying-for-business').hide();

            }

            // Mobile sticky message
            if (window.mobile_sticky_messages != undefined) {
                let mobileMessage = jQuery('.next-message');
                mobileMessage.html('');
                window.mobile_sticky_messages.forEach(function (el) {
                    if (totalproducts >= el.min && totalproducts <= el.max) {
                        mobileMessage.html(el.message);
                    }
                });
            }
        });

        jQuery('.open-how-often').click(function () {
            const minimum = jQuery(this).attr('data-minimum');
            const humanminimum = jQuery(this).attr('data-minimum-human');

            let totalproducts = 0;

            jQuery('.jic-subscription-builder').find('input[type="number"]').each(function () {
                totalproducts += parseInt(jQuery(this).val());
            });

            if (totalproducts < minimum) {
                if(jQuery('p.error').length < 1){
                    jQuery(`<p class='error text-right' style="margin-right: 1rem;">Please select at least ${humanminimum} product for your subscription.</p>`).insertBefore(jQuery(this));
                }
            } else {
                jQuery('p.error').remove();

                jQuery('.section-subscription-progress .step').removeClass('active');
                jQuery('.section-subscription-progress .step-2').addClass('active');
                jQuery('.subscription-action-buttons').hide();
                jQuery('.jic-subscription-builder').hide();
                jQuery('.accordion-wrapper').hide();
                jQuery('.subscription-preferences').show();
                jQuery('.subscription-sub-list-text').hide();
                jQuery('.subscription-sub-list-text.step-2').show();

                jQuery('.subscription-preferences').find('.subscription-option:nth-child(2)').find('input').prop('checked', true);

                window.scrollTo({ top:jQuery('.section-subscription-builder').offset().top - 150, left:0, behavior: "instant"});
            }
        });

        jQuery('.open-bundle-section').click(function () {
            // e.preventDefault();

            window.scrollTo({ top:jQuery('.section-subscription-builder').offset().top - 150, left:0, behavior: "instant"});

            jQuery('.section-subscription-progress .step').removeClass('active');
            jQuery('.section-subscription-progress .step-1').addClass('active');
            jQuery('.subscription-action-buttons').show();
            jQuery('.jic-subscription-builder').show();
            jQuery('.accordion-wrapper').show();
            jQuery('.subscription-preferences').hide();
            jQuery('.subscription-sub-list-text').hide();
            jQuery('.subscription-sub-list-text.step-1').show();

            window.scrollTo({ top:jQuery('.section-subscription-builder').offset().top - 150, left:0, behavior: "instant"});

        });

        jQuery(document).on('click', '.section-subscription-progress .step:not(.active)', function (){
            console.log('step clicked - ', jQuery(this));
            console.log('step clicked class - ', jQuery(this).hasClass('step-1'));
            if(jQuery(this).hasClass('step-1')) {
                jQuery('.open-bundle-section').click();
            } else {
                jQuery('.open-how-often').click();
            }
        });

        jQuery(productList).parents('.accordion-wrapper').find('.accordion-heading').click(function () {
            jQuery('.section-subscription-builder').toggleClass('acc-open');
            if (jQuery('.section-subscription-builder').hasClass('acc-open')) {
                jQuery('html, body').animate({scrollTop: jQuery(productList).offset().top - 150}, 'fast');
            } else {
                window.scrollTo({ top:jQuery('.section-subscription-builder').offset().top - 150, left:0, behavior: "instant"})
            }
        });
        
    }

    getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) return null;
        }
        else
        {
            begin += 2;
            var end = document.cookie.indexOf(";", begin);
            if (end == -1) {
            end = dc.length;
            }
        }
        // because unescape has been deprecated, replaced with decodeURI
        //return unescape(dc.substring(begin + prefix.length, end));
        return decodeURI(dc.substring(begin + prefix.length, end));
    }

    _initOptionsAndSubmit () {

        var _this = this;
        var productOptions = document.querySelectorAll(_this.selectors.productOptions);
        var subscriptionOptions = document.querySelectorAll(_this.selectors.subscriptionOptions);

        jQuery('.submit-subscription').click(function(){

            var button = jQuery(this);

            button.prop("disabled", true).addClass('running');

            let selectedInput = jQuery(subscriptionOptions).first().find('input[type="radio"]:checked');
            let inputLabel = selectedInput.attr('data-plan-name');
            var planSelection = jQuery(subscriptionOptions).first().find('input[type="radio"]:checked').val();

            var items = [];

            for(var i = 0; i < productOptions.length; i++){

                var product = productOptions[i];

                console.log('product - ', product);

                var input = jQuery(product).find('input[type="number"]');
                var inputId = input.attr('id');
                var inputQty = input.val();

                /* SKIO updates to grab SKIO selling plan */
                var productId = jQuery(product).find('input[type="number"]').attr('productId');
                console.log('productId - ', productId);
                console.log(`[data-bsub-product-json][data-bsub-product-id="${ productId }"]`);
                let productJson = JSON.parse(document.querySelector(`[data-bsub-product-json][data-bsub-product-id="${ productId }"]`).innerHTML);

                console.log('productJson', productJson)

                let selling_plan_group = productJson?.selling_plan_groups?.find(x => x.app_id == "SKIO");
                
                console.log('selling_plan_groups', selling_plan_group)

                console.log('inputId', inputId)
                console.log('inputLabel', inputLabel)
                
                // let selling_plan_group = selling_plan_groups?.options?.find(x => x.options[0].name.includes(inputId));

                // console.log('selling_plan_group', selling_plan_group)
                
                let selling_plan = selling_plan_group?.selling_plans?.find(x => x.name.includes(inputLabel));

                console.log('selling_plan', selling_plan)

                if(inputQty > 0) {
                    items.push({
                        id: inputId,
                        quantity: inputQty,
                        selling_plan: selling_plan?.id
                    })
                }

            }

            console.log('items', items)

            var fetchpromises = [];

            async function addToCart() {
                let results = [];

                let formData = {
                    'items': []
                };

                for (let item of items) {
                    let config = fetchConfig('javascript');
                    let jsonData = item;
                    var codes = [];

                    if (_this.getCookie('discount_code') !== null) {
                        codes.push(_this.getCookie('discount_code'));
                    }
                    
                    if(window.settings.codes.length > 0){
                        codes = codes.concat(window.settings.codes.split(','));
                    }

                    if(codes.length > 0){
                        jsonData['codes'] = codes.join(',');
                    }

                    config.body = JSON.stringify(jsonData);
                    config.body = JSON.stringify(jsonData);
                    console.log('ADDING CONFIG', config);
                    /*let r = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
                      console.log('RESPONSE', response);
                      if ('id' in response && response.id) {
                        // console.log('setting cart ID')
                        window.localStorage.setItem('cart', response.id);
                      }
                    })*/

                    // Use standard Shopify cart/add.js API
                    formData.items.push({
                        'id': item.id,
                        'quantity': item.quantity,
                        'selling_plan': item.selling_plan
                    });
                }
                if (formData.items.length > 0) {
                    let r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    });

                    results.push(r);
                }
                return results;
            }

            addToCart()
            .then((results) => {

                console.log('RESULTS', results);

                // Goto Checkout page
                window.location.href = window.Shopify.routes.root + 'checkout';

                //window.dispatchEvent(new Event("cartrefresh"));
                //window.dispatchEvent(new Event("cartopen"));

                button.prop("disabled", false).removeClass('running');

            });

        });

    }
}

export default SubscriptionBuilder;